<template>
    <span>
        <i :class="['mr-1', iconClass, config.color]"></i>
        {{ $t(`labels.ai_process_statuses.${status}`) }}
        <span v-if="count !== null"> ({{ count }})</span>
    </span>
    <span v-if="exceptionReason" class="d-block text-muted font-size-sm">
        {{ $t(getAiProcessTaskExceptionReasonLabelKey(exceptionReason)) }}
    </span>
</template>
<script>
import { getAiProcessTaskExceptionReasonLabelKey } from '../../../enums/AiProcessTaskExceptionReasonEnum';

const STATUS_CONFIG = {
    waiting:   { icon: 'icon-alarm',           spinnerIcon: 'icon-alarm',    color: 'text-warning' },
    process:   { icon: 'icon-spinner4 spinner', spinnerIcon: 'icon-spinner4', color: 'text-primary' },
    success:   { icon: 'icon-checkmark3',       spinnerIcon: 'icon-checkmark3', color: 'text-success' },
    problem:   { icon: 'icon-cross2',           spinnerIcon: 'icon-cross2',   color: 'text-danger' },
    confirmed: { icon: 'icon-checkmark-circle', spinnerIcon: 'icon-checkmark-circle', color: 'text-teal' },
    cancelled: { icon: 'icon-blocked',          spinnerIcon: 'icon-blocked',  color: 'text-secondary' },
};

export default {
    name: 'AiProcessTaskStatusComponent',
    props: {
        status: {
            type: String,
            required: true,
        },
        count: {
            type: Number,
            default: null,
        },
        spinner: {
            type: Boolean,
            default: true,
        },
        exceptionReason: {
            type: String,
            default: null,
        },
    },
    methods: {
        getAiProcessTaskExceptionReasonLabelKey,
    },
    computed: {
        config() {
            return STATUS_CONFIG[this.status] ?? {};
        },
        iconClass() {
            return this.spinner ? this.config.icon : this.config.spinnerIcon;
        },
    },
};
</script>
